<div
  [ngClass]="availability() | publicSalesAvailabilityBadgeCssClass | async"
  class="p-2 text-sm font-bold uppercase">
  {{ availability() | publicSalesAvailabilityLabel | async }}
</div>
